import {initHiddenYandexCaptcha, resetInitedYandexCaptcha} from "../yandex_smart_captcha/smartCaptcha";
import {VGFormSender} from "vgformsender";
import {Modal} from "../../../../../../modules/index.esm";

function toggleSubmitButtons(form, disabled) {
	const submitButtons = [
		...form.querySelectorAll('[type="submit"]'),
		...(form.id ? document.querySelectorAll('[form="' + form.id + '"]') : [])
	];

	submitButtons.forEach(function (button) {
		button.disabled = disabled;
	});
}

function resolveContainer(container) {
	if (container && typeof container.querySelectorAll === 'function') {
		return container;
	}

	if (container?.target && typeof container.target.querySelectorAll === 'function') {
		return container.target;
	}

	return document;
}

function hideOpenedModals() {
	[... document.querySelectorAll('.modal.show')].forEach(el => {
		const modal = Modal.getOrCreateInstance(el);
		modal.hide();
	})
}

function ready(container = document) {
	const root = resolveContainer(container);

	[...root.querySelectorAll('[data-vgformsender]')].forEach(function (form) {
		if (form.dataset.vgformsenderInited === '1') {
			return;
		}
		form.dataset.vgformsenderInited = '1';

		let formSender = new VGFormSender(form);
		let allowSubmit = false;
		let lastSubmitter = null;

		form.addEventListener('submit', function (event) {
			if (allowSubmit) {
				allowSubmit = false;
				return;
			}

			lastSubmitter = event.submitter || null;
			event.preventDefault();
			event.stopImmediatePropagation();
			toggleSubmitButtons(form, true);

			initHiddenYandexCaptcha(form).then(function () {
				allowSubmit = true;
				toggleSubmitButtons(form, false);
				setTimeout(function () {
					if (typeof form.requestSubmit === 'function') {
						if (lastSubmitter) {
							form.requestSubmit(lastSubmitter);
							lastSubmitter = null;
							return;
						}
						form.requestSubmit();
						lastSubmitter = null;
						return;
					}
					form.dispatchEvent(new Event('submit', {bubbles: true, cancelable: true}));
					lastSubmitter = null;
				}, 0);
			}).catch(function () {
				lastSubmitter = null;
				toggleSubmitButtons(form, false);
			});
		}, true);

		formSender.submit({
			beforeSend: () => {
				toggleSubmitButtons(form, true);
			},
			error: () => {
				toggleSubmitButtons(form, false);
				resetInitedYandexCaptcha(form);
				hideOpenedModals();
			},
			success: () => {
				toggleSubmitButtons(form, false);
				resetInitedYandexCaptcha(form);
				hideOpenedModals();
			},
		});
	});
}

document.addEventListener('DOMContentLoaded', ready);

if (typeof $ !== 'undefined') {
	$(document).on('modal-loaded onload', function (event) {
		ready(event);
	});
}

typeof onTurboRender !== 'undefined' && onTurboRender(ready);
